//Node imports
import { AnimationSymbol, LayeredAnimationSymbol, SpineSymbol, StaticSymbol, SymAnimReel, SymbolConstants } from "@quest/slot-core";
import { Reel } from "@quest/murka-games-behavior-leopard/dist"
import { Container, delayedCall, ingenuity } from "@quest/base-core";
import { SlotEventConstants } from "@quest/slot-core/dist/SlotConstants/SlotEventDispatchers";

//Game imports
import { gameConstants } from "../Constants/gameConstants";
import { GameParserModel } from "../Platform/GameParserModel";

export class ReelAT extends Reel {

  /** update on spin */
  public updateSpin(deltaTime: number) {
    if (!this.spinNow) {
      return;
    }
    let id: number;
    let icon;
    let sym;
    // Checking whether the reel has moved beyond the symbol height, if yes then its y is reset to 0 and loop is incremented.
    if (this.initScroll >= this.model.getSymbolHeight()) {
      // loop incremented
      this.intLoopCounter++;
      // variable which changes y is reset to 0.
      this.initScroll = 0;
      //  flag to check if we need to remove symbol from list
      let removeSymbolFromList: boolean = false;
      // shifting each symbol one position down and removing symbol which go two positions down the visible area
      this.symCollection.forEach((symbol, index) => {
        if (typeof symbol !== "undefined") {
          icon = symbol.getStatic();
          //  Based on spinDirection, update grid position on reel.
          if (this.spinDirection === 1) {
            symbol.setYPosition(symbol.y + this.model.getSymbolHeight() + (this.model.getSymbolSpacingY() || 0));
            symbol.gridPosition++;
          }
          else {
            symbol.setYPosition(symbol.y - (this.model.getSymbolHeight() + (this.model.getSymbolSpacingY() || 0)));
            symbol.gridPosition--;
          }
          icon.visible = true;
          symbol.forceHide = false;
          if (symbol.json.spinStartSym) {
            let spinIcon = symbol.getSpinStartSymAnimation();
            if (!((symbol.gridPosition > this.rows && this.spinDirection === 1) || (symbol.gridPosition < -1 && this.spinDirection === 0))) {
              spinIcon.visible = true;
              this.addChildAt(spinIcon, symbol.gridPosition);
              if (spinIcon instanceof StaticSymbol || spinIcon instanceof SpineSymbol) {
                spinIcon.playAnim(SymbolConstants.DEFAULT_ANIMATION_KEY);
              }
              else if (spinIcon instanceof AnimationSymbol) {
                spinIcon.playAnim(SymbolConstants.DEFAULT_ANIMATION_KEY, undefined, () => {
                  spinIcon.visible = false;
                  this.removeChild(spinIcon);
                });
              }
              else if (spinIcon instanceof LayeredAnimationSymbol) {
                spinIcon.playAnim();
              }
            }
          }
          //  Check for gridPosition based on spinDirection. If symbol is offscreen, remove it.
          if ((symbol.gridPosition > this.rows && this.spinDirection === 1) || (symbol.gridPosition < -1 && this.spinDirection === 0)) {
            if (symbol.json.spinSym) {
              const spinIcon = symbol.getSpinAnimation();
              spinIcon.stopAnim();
            }
            symbol.returnToPool();
            // make the symbol undefined. This is to ensure loop runs through each element.
            this.symCollection[index] = undefined;
            removeSymbolFromList = true;
            icon.off(SlotEventConstants.SYMBOL_ANIM_STARTED);
            icon.off(SlotEventConstants.SYMBOL_ANIM_ENDED);
          }
        }
      });
      // The flag is true and loop is complete. Remove symbol based on direction.
      if (removeSymbolFromList) {
        const len: number = this.symCollection.length;
        for (let i: number = len - 1; i >= 0; i--) {
          if (typeof this.symCollection[i] === "undefined") {
            this.symCollection.splice(i, 1);
          }
        }
      }
      // checking if the stops have been set then pick symbols from stop positions otherwise pick from the reelset
      // intMaxLoops is used for anticipation spin and for asymmetric reels.
      if (Array.isArray(this.stops) && this.stops.length > 0 && this.intLoopCounter >= this.intMaxLoops) {
        // DJ :: based on direction, get the stop symbol ID (from top or bottom) and increment/decrement stopIndex
        // DJ :: Add symbol to collection based on direction. It should be top or bottom.
        // DJ :: Symbol position in grid is dependent on direction.
        if (this.spinDirection === 1) {
          const id: number = this.stops[this.stopIndex - 1] as number;
          sym = this.iconsPool.getSymbol(id);
          this.symCollection.unshift(sym);
          sym.gridPosition = -1;
          this.stopIndex--;
        }
        else {
          const id: number = this.stops[this.stopIndex] as number;
          sym = this.iconsPool.getSymbol(id);
          this.symCollection.push(sym);
          sym.gridPosition = this.rows;
          this.stopIndex++;
        }
        icon = sym.getStatic();
        icon.visible = true;
        if (ingenuity.configData.decreaseSpinSpeed) {
          if (this.model.json.decSpinSpeed) {
            this.initSpinSpeed =
              this.initSpinSpeed > this.model.json.minSpeed ? this.initSpinSpeed - this.model.json.decSpinSpeed : this.model.json.minSpeed;
          }
          else {
            this.initSpinSpeed--;
          }
          this.quickSpinSpeed--;
        }
        if (!icon.hasEvent(SlotEventConstants.SYMBOL_ANIM_STARTED)) {
          icon.on(SlotEventConstants.SYMBOL_ANIM_STARTED, this.onSymbolAnimationEvent, this);
        }
        if (!icon.hasEvent(SlotEventConstants.SYMBOL_ANIM_ENDED)) {
          icon.on(SlotEventConstants.SYMBOL_ANIM_ENDED, this.onSymbolAnimationEvent, this);
        }
      }
      else {
        // DJ :: Based on direction, we need to pick index to get next symbol from reel.
        // DJ :: Add symbol to collection based on direction. It should be top or bottom.
        // DJ :: Symbol position in grid is dependent on direction.
        if (this.spinDirection === 1) {
          id = this.model.getCurrentReelset()[this.reelId][this.index];
          sym = this.iconsPool.getSymbol(id);
          this.symCollection.unshift(sym);
          sym.gridPosition = -1;
        }
        else {
          id = this.model.getCurrentReelset()[this.reelId][this.upindex];
          sym = this.iconsPool.getSymbol(id);
          this.symCollection.push(sym);
          sym.gridPosition = this.rows;
        }
        if (sym.json.spinSym) {
          icon = sym.getSpinAnimation();
          this.playSymbolSpinAnimation(icon);
        }
        else if (this.blurSpin) {
          icon = sym.getBlur();
          this.fadeSpinningSymbolOnAnticipation(icon)
        }
        else {
          icon = sym.getStatic();
        }
        icon.visible = true;
      }
      // DJ :: Position where symbol needs to be added in reel.
      let yPos: number = 0;
      if (this.spinDirection === 1) {
        yPos = -this.model.getSymbolHeight() - (this.model.getSymbolSpacingY() || 0);
      }
      else {
        yPos = this.model.getSymbolHeight() * this.rows + (this.model.getSymbolSpacingY() || 0);
      }
      sym.setYPosition(yPos);
      (sym.parent as any) = this;
      this.addChildAt(icon, 0);
      // DJ :: Once all symbols are displayed, we need to stop reels.
      // Code below running in loop checks stopSpinNow and if true, ends spin.
      if ((this.spinDirection === 1 && this.stopIndex === 0) || (this.spinDirection === 0 && this.stopIndex === this.rows + 2)) {
        this.stopSpinNow = true;
      }
    }
    // moving the reels up or down based on the spin direction
    this.y =
      this.spinDirection === 1
        ? this.model.reelJson[this.reelId].y + this.initScroll
        : -(this.model.reelJson[this.reelId].y + this.initScroll);
    let delta: number = deltaTime / this.desiredFPSTime, speed, qSpeed;
    if (delta > 1) {
      qSpeed = this.quickSpinSpeed * delta;
      speed = this.initSpinSpeed * delta;
    }
    else {
      qSpeed = this.quickSpinSpeed;
      speed = this.initSpinSpeed;
    }
    if (this.model.quickSpin) {
      this.initScroll += qSpeed + this.anticipationSpeed;
    }
    else {
      this.initScroll += speed + this.anticipationSpeed;
    }
    if (ingenuity.configData.hasOverlaySymbols) {
      this.sortIconsOnType();
    }
    // this block of code is executed when all the symbols have been placed and bounce before the stop is played
    // reel_stopping event is fired
    if (this.stopSpinNow) {
      this.spinNow = false;
      this.handleReelStop();
      if (!this.model.noStopBounce) {
        // let stopBounceAmt = this.model.getReelConfig(this.reelId).stopBounceAmt || (this.model.getSymbolHeight() * 0.15);
        const stopBounceAmt = Array.isArray(this.model.stopBounceAmt) ? this.model.stopBounceAmt[this.reelId] : this.model.stopBounceAmt;
        // let stopBounceTime = this.model.getReelConfig(this.reelId).stopBounceTime || 150;
        const stopBounceTime = Array.isArray(this.model.stopBounceTime)
          ? this.model.stopBounceTime[this.reelId]
          : this.model.stopBounceTime;
        // let stopBounceTimeout = this.model.getReelConfig(this.reelId).stopBounceTimeout || 100;
        const stopBounceTimeout = Array.isArray(this.model.stopBounceTimeout)
          ? this.model.stopBounceTimeout[this.reelId]
          : this.model.stopBounceTimeout;
        const bounce = this.game.add.tween(this);
        // DJ :: Stop bounce effect based on direction to stop reels.
        bounce.to({
          y: this.spinDirection === 1 ? this.y + stopBounceAmt : this.y - stopBounceAmt,
        }, stopBounceTime, ingenuity.configData.reelStopBounceInEase, false);
        bounce.to({
          y: this.spinDirection === 1 ? this.model.reelJson[this.reelId].y : -this.model.reelJson[this.reelId].y,
        }, stopBounceTimeout, ingenuity.configData.reelStopBounceOutEase, false);
        bounce.onComplete.add(this.spinDone, this);
        bounce.start();
      }
      else {
        delayedCall("stopReel", 10, this.spinDone, this);
      }
    }
  }


  /*
   * function will fade the spinning symbols except bonus symbol
   * only those symbols will fade which are spinning next to the reel with anticipation
   */
  private fadeSpinningSymbolOnAnticipation(symbol: StaticSymbol): void {
    if (ingenuity.configData.currentAnticipation !== -1 && this.reelId > ingenuity.configData.currentAnticipation) {
      symbol.tint = gameConstants.FADED_SYMBOL;
    } else {
      symbol.tint = gameConstants.UNFADED_SYMBOL;
    }
  }

  /*
   * Override to stop symbol and add in win presentation in case of stack symbol offset exists in win offset
   */
  public playAnimByPos(pos: number, symReel?: Container, opts?: SymAnimReel): void {
    const parent: any = this.parent;
    const sym = parent.getSymbolByPos(this.reelId, pos);
    sym.getStatic().visible = false;
    const icon = sym.getAnimation();
    const stackOffset: number[][][] = (ingenuity.parserModel as GameParserModel).getCommonOffsetsOfStackAndWin();
    if (!icon) {
      return;
    }
    if (!icon.hasEvent(SlotEventConstants.SYMBOL_ANIM_STARTED)) {
      icon.on(SlotEventConstants.SYMBOL_ANIM_STARTED, this.onSymbolAnimationEvent, this);
    }
    if (!icon.hasEvent(SlotEventConstants.SYMBOL_ANIM_ENDED)) {
      icon.on(SlotEventConstants.SYMBOL_ANIM_ENDED, this.onSymbolAnimationEvent, this);
    }
    const symPosition: number[] = [this.reelId, pos];
    const offsetFind: boolean = this.findStackAnimSym(stackOffset, symPosition);
    !offsetFind && symReel.addChild(icon);
    icon.visible = !sym.forceHide;
    this.hiddenIcons.push(icon);
    if (!this.checkSymbolInArray(icon)) {
      this.AllIcons.push(icon);
    }
    const staticAnim = icon.json.animations ? icon.json.animations.static : "static";
    const winAnim = icon.json.animations ? icon.json.animations.anim : "animation";
    icon.playAnim(staticAnim, false, 0);
    setTimeout(() => {
      icon.playAnim(winAnim);
    }, 1);
  }

  /*
   * Method is use to check is symbol is present in grid or not
   */
  protected checkSymbolInArray(icon: any) {
    let isSymbolAvailable: boolean = false;
    for (const element of this.AllIcons) {
      if (element.gridPosition === icon.gridPosition) {
        isSymbolAvailable = true;
      }
    }
    return isSymbolAvailable;
  }

  /*
   * Function is use to check if stack present or not
   */
  private findStackAnimSym(symGrid: number[][][], stackOffset: number[]): boolean {
    for (let reelOffsets of symGrid) {
      for (let i: number = 0; i < reelOffsets.length; i++) {
        if (reelOffsets.length > 1) {
          if (reelOffsets[i][0] === stackOffset[0] && reelOffsets[i][1] === stackOffset[1]) {
            return true;
          }
        }
      }
    }
    return false; // Element is not present
  }

  /*
   * Method Override for not playing scatter triggering animation in loop
   */
  public playTriggerAnimByID(id: number, pos: number, symReel?: Container, opts?: any) {
    let parent: any = this.parent;
    const sym = parent.getSymbolByPos(this.reelId, pos);
    sym.getStatic().visible = false;
    const icon = sym.getAnimation();
    if (!icon.hasEvent(SlotEventConstants.SYMBOL_ANIM_STARTED)) {
      icon.on(SlotEventConstants.SYMBOL_ANIM_STARTED, this.onSymbolAnimationEvent, this);
    }
    if (!icon.hasEvent(SlotEventConstants.SYMBOL_ANIM_ENDED)) {
      icon.on(SlotEventConstants.SYMBOL_ANIM_ENDED, this.onSymbolAnimationEvent, this);
    }
    this.scatterIcons.push(icon);
    symReel && symReel.addChild(icon);
    icon.visible = !sym.forceHide;
    icon.playAnim("static", false, 0);
    setTimeout(() => {
      icon.playAnim(opts || "win", false);
    }, 1);
    return sym;
  }
}